import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';

import { Tab, TabType } from '../Tab';
import { TabsProps } from '../Tabs';
import tabsCss from '../Tabs.module.css';
import { StickyPagination } from './StickyPagination';

import css from './Sticky.module.css';

const Sticky = (props: TabsProps) => {
  const { tabsData, onChange, onPin } = props;

  const {
    app: { i18n, loading, searchLoads },
  } = useStore();

  if (typeof window === 'undefined') return null;

  const handleRefreshClick = () => {
    searchLoads();
  };

  return (
    <div className={cn(css.container, 'ls-tabs')}>
      <div className={css.tabs}>
        <button className={cn(tabsCss.pinButton, tabsCss.pinButton_sticky)} onClick={onPin}>
          <Icon color="var(--dark)" height={14} name="ic_pin" width={14} />
        </button>

        {tabsData.slice(0, tabsData.length - 1).map((tab: TabType) => (
          <Tab
            key={tab.id}
            isSticky
            className={css.stickyTab}
            isActive={tab.id === props.activeTab}
            tab={tab}
            tooltipPosition="bottom"
            onChange={onChange}
          >
            {tab.label}
          </Tab>
        ))}
      </div>

      <StickyPagination />

      <div className={css.action}>
        <button
          className={cn(css.actionButton, 'glz-button', 'glz-is-primary', 'glz-is-outlined', 'glz-is-small', {
            'glz-is-loading': loading.search,
          })}
          disabled={loading.search}
          type="button"
          onClick={handleRefreshClick}
        >
          <Icon className={css.refreshIcon} color="currentColor" height={12} name="ic_refresh" width={12} />
          {i18n.app.refresh}
        </button>
      </div>
    </div>
  );
};

const connected = observer(Sticky);

export { connected as Sticky };
